import { render } from "./HermesReporting.vue?vue&type=template&id=bad0a734&scoped=true"
import script from "./HermesReporting.vue?vue&type=script&lang=js"
export * from "./HermesReporting.vue?vue&type=script&lang=js"

import "./HermesReporting.vue?vue&type=style&index=0&id=bad0a734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad0a734"]])

export default __exports__